module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigilnotintoc sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "id": "CONTENTS"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003_split_000#TALES_OF_ADVENTURE"
    }
  }, [_vm._v("TALES OF ADVENTURE")]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0003_split_000#I"
    }
  }, [_vm._v("I. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Début of Bimbashi Joyce")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0004#II"
    }
  }, [_vm._v("II. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Surgeon of Gaster Fell")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0005#III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Borrowed Scenes")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0006#IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Man from Archangel")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0007#V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Great Brown-Pericord Motor")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0008_split_000#VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Sealed Room")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0008_split_001#TALES_OF_MEDICAL_LIFE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TALES OF MEDICAL LIFE")]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0008_split_001#VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Physiologist's Wife")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0011#VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Behind the Times")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0012#IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("His First Operation")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0013#X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Third Generation")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0014#XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Curse of Eve")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0015#XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Medical Document")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0016#XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Surgeon Talks")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Doctors of Hoyland")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0019#XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Crabbe's Practice")])]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0